// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("range-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-sbs-range {
    -webkit-appearance: none;
    display: inline-block!important;
    vertical-align: middle;
    height: 0;
    padding: 0;
    margin: 0;
    border: 0;
    background: rgba(0, 0, 0, 0.25);
    min-width: 100px;
    cursor: pointer;
    pointer-events: none;
    z-index: 999;
}
.leaflet-sbs-range::-ms-fill-upper {
    background: transparent;
}
.leaflet-sbs-range::-ms-fill-lower {
    background: rgba(255, 255, 255, 0.25);
}
/* Browser thingies */

.leaflet-sbs-range::-moz-range-track {
    opacity: 0;
}
.leaflet-sbs-range::-ms-track {
    opacity: 0;
}
.leaflet-sbs-range::-ms-tooltip {
    display: none;
}
/* For whatever reason, these need to be defined
 * on their own so dont group them */

.leaflet-sbs-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin: 0;
    padding: 0;
    background: #fff;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: ew-resize;
    pointer-events: auto;
    border: 1px solid #ddd;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 40px 40px;
}
.leaflet-sbs-range::-ms-thumb {
    margin: 0;
    padding: 0;
    background: #fff;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: ew-resize;
    pointer-events: auto;
    border: 1px solid #ddd;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 40px 40px;
}
.leaflet-sbs-range::-moz-range-thumb {
    padding: 0;
    right: 0    ;
    background: #fff;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: ew-resize;
    pointer-events: auto;
    border: 1px solid #ddd;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 40px 40px;
}
.leaflet-sbs-range:disabled::-moz-range-thumb {
    cursor: default;
}
.leaflet-sbs-range:disabled::-ms-thumb {
    cursor: default;
}
.leaflet-sbs-range:disabled::-webkit-slider-thumb {
    cursor: default;
}
.leaflet-sbs-range:disabled {
    cursor: default;
}
.leaflet-sbs-range:focus {
    outline: none!important;
}
.leaflet-sbs-range::-moz-focus-outer {
    border: 0;
}

`, "",{"version":3,"sources":["webpack://./node_modules/leaflet-side-by-side/range.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,SAAS;IACT,SAAS;IACT,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qCAAqC;AACzC;AACA,qBAAqB;;AAErB;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;oCACoC;;AAEpC;IACI,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,yDAAqC;IACrC,4BAA4B;IAC5B,4BAA4B;IAC5B,0BAA0B;AAC9B;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,yDAAqC;IACrC,4BAA4B;IAC5B,4BAA4B;IAC5B,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,yDAAqC;IACrC,4BAA4B;IAC5B,4BAA4B;IAC5B,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,SAAS;AACb","sourcesContent":[".leaflet-sbs-range {\r\n    -webkit-appearance: none;\r\n    display: inline-block!important;\r\n    vertical-align: middle;\r\n    height: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    background: rgba(0, 0, 0, 0.25);\r\n    min-width: 100px;\r\n    cursor: pointer;\r\n    pointer-events: none;\r\n    z-index: 999;\r\n}\r\n.leaflet-sbs-range::-ms-fill-upper {\r\n    background: transparent;\r\n}\r\n.leaflet-sbs-range::-ms-fill-lower {\r\n    background: rgba(255, 255, 255, 0.25);\r\n}\r\n/* Browser thingies */\r\n\r\n.leaflet-sbs-range::-moz-range-track {\r\n    opacity: 0;\r\n}\r\n.leaflet-sbs-range::-ms-track {\r\n    opacity: 0;\r\n}\r\n.leaflet-sbs-range::-ms-tooltip {\r\n    display: none;\r\n}\r\n/* For whatever reason, these need to be defined\r\n * on their own so dont group them */\r\n\r\n.leaflet-sbs-range::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url(range-icon.png);\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range::-ms-thumb {\r\n    margin: 0;\r\n    padding: 0;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url(range-icon.png);\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range::-moz-range-thumb {\r\n    padding: 0;\r\n    right: 0    ;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url(range-icon.png);\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range:disabled::-moz-range-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled::-ms-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled::-webkit-slider-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:focus {\r\n    outline: none!important;\r\n}\r\n.leaflet-sbs-range::-moz-focus-outer {\r\n    border: 0;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
